import React  from 'react';
  
//../../shared/constants/AppConst
export const helpSupportConfig = [
  {
    auth: ['user'],
    routes: [
      {
        path: '/helpSupport',
        component: React.lazy(() => import('./HelpTabs')),
      },
    ],
  },
  
];
